import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "Tournaments" */ './components/Tournaments'));
